import { render, staticRenderFns } from "./exportinfections.vue?vue&type=template&id=6fc1b839&scoped=true"
import script from "./exportinfections.vue?vue&type=script&lang=js"
export * from "./exportinfections.vue?vue&type=script&lang=js"
import style0 from "./exportinfections.vue?vue&type=style&index=0&id=6fc1b839&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6fc1b839",
  null
  
)

export default component.exports